import { Component } from '@angular/core';
import { AsyncPipe, CurrencyPipe, PercentPipe, NgClass } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { IonicModule } from '@ionic/angular';
import { RoiService } from '@smartflip/ui-utils';
import { PropertyRecommendationRatingComponent } from '../PropertyRecommendationRating/PropertyRecommendationRating.component';
import { DEFAULT_PROFIT_THRESHOLD } from './PropertyRecommendation.constants';
import { UserService } from '../../../../../services/helper-utils/src/lib/user.service';

@Component({
  selector: 'lib-property-recommendation',
  imports: [
    AsyncPipe,
    CurrencyPipe,
    IonicModule,
    PercentPipe,
    NgClass,
    PropertyRecommendationRatingComponent,
  ],
  templateUrl: './PropertyRecommendation.component.html',
  styleUrl: './PropertyRecommendation.component.scss',
})
export class PropertyRecommendationComponent {
  // TODO: Make the threshold user-configurable
  public profitThreshold = DEFAULT_PROFIT_THRESHOLD;
  public estimatedProfitIn6Months$ = new BehaviorSubject<number>(0.25);
  public topRecommendation = false;
  public recommendationScore = 0;
  public minimumProfitableSalesPrice = 0;

  constructor(
    private roiService: RoiService,
    private userService: UserService,
  ) {
    this.userService.loggedInUser$.subscribe((user) => {
      if (user?.financialSettings?.minimumProfitMarginPercent !== undefined) {
        this.profitThreshold =
          user.financialSettings.minimumProfitMarginPercent;
      }
    });
  }

  private calculateRating(profitPercentage: number = 0): number {
    let starRating = 0;
    if (profitPercentage >= this.profitThreshold + DEFAULT_PROFIT_THRESHOLD) {
      starRating = 3;
    } else if (profitPercentage >= this.profitThreshold) {
      starRating = 2;
    } else if (profitPercentage >= this.profitThreshold - 0.1) {
      starRating = 1;
    } else {
      starRating = 0;
    }

    return starRating;
  }

  private calculateMinimumProfitableSalesPrice() {
    this.roiService.calculationValues$.subscribe((calcValues) => {
      const totalCosts = calcValues?.allCosts || 0;
      this.minimumProfitableSalesPrice =
        totalCosts * (1 + DEFAULT_PROFIT_THRESHOLD);
    });
  }

  private profitPercentageInSixMonths() {
    this.roiService.calculationValues$.subscribe((calcValues) => {
      const profit = calcValues?.profit || 0;
      const totalCosts = calcValues?.allCosts || 1; // Prevent division by zero
      const profitPercentage = profit / totalCosts;
      // TODO: Consider making the threshold user-configurable
      this.topRecommendation =
        profitPercentage >= this.profitThreshold + DEFAULT_PROFIT_THRESHOLD;
      this.recommendationScore = this.calculateRating(profitPercentage);

      this.estimatedProfitIn6Months$.next(profitPercentage);
    });
  }

  ngOnInit() {
    this.profitPercentageInSixMonths();
    this.calculateRating();
    this.calculateMinimumProfitableSalesPrice();
  }
}
